import ImgPlayer from '@/shared/pictures/player.png';
import ImgPlayerFire from '@/shared/pictures/player_fire.png';
import ImgGoalkeeper from '@/shared/pictures/goalkeeper.png';
import ImgGate from '@/shared/pictures/gate.png';
import ImgSquare from '@/shared/pictures/square.png';
import ImgPuck from '@/shared/pictures/puck.png';
import ImgPuckGold from '@/shared/pictures/puck_gold.png';
import ImgPuckFire from '@/shared/pictures/puck_fire.png';

import ImgWheel from '@/shared/pictures/wheel_new.png';
import ImgStick from "@/shared/pictures/stick.png";
import ImgCenter from "@/shared/pictures/center.png";

import GoalImg from '@/shared/pictures/goal.png';
import MissImg from '@/shared/pictures/miss.png';
import StarImg from '@/shared/pictures/star.png';

export const IMAGES = {
    player: ImgPlayer,
    playerFire: ImgPlayerFire,
    goalkeeper: ImgGoalkeeper,
    gate: ImgGate,
    square: ImgSquare,
    puck: ImgPuck,
    puckGold: ImgPuckGold,
    puckFire: ImgPuckFire,
    goal: GoalImg,
    miss: MissImg,
    star: StarImg,
    wheel: ImgWheel,
    stick: ImgStick,
    center: ImgCenter,
} as const;

export type ImageKey = keyof typeof IMAGES;


export const PreloadedImages: Record<ImageKey, HTMLImageElement> =
    {} as any;

export function preloadAllImages(): Promise<void> {
    const promises = Object.entries(IMAGES).map(([key, src]) => {
        return new Promise<void>((resolve) => {
            const img = new Image();
            img.src = src;
            img.onload = () => {
                PreloadedImages[key as ImageKey] = img;
                resolve();
            };

            img.onerror = () => {
                console.warn("Failed to preload:", src);
                resolve();
            };
        });
    });

    return Promise.all(promises).then(() => undefined);
}
